/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  CopyLinkInput,
  ButtonSecondary,
  ButtonPrimary,
} from '@americanexpress/dls-react';
import { FxModal } from './FxModals/FxModal';
import { generatePassword } from '../utils/generatePasswordUtil';
import { status } from '../constants';

const passwordGeneratorModalTheme = {
  width: 'none',
  height: 'none',
  position: 'none',
  border: '.0625rem solid #ecedee',
};

export const FxPasswordGenerator = ({
  onPasswordModalClose,
  onPasswordFillButtonClick,
  styles = {},
}) => {
  const [password, setPassword] = useState(generatePassword());
  const [copyPasswordStatus, setCopyPasswordStatus] = useState('');

 const onRefreshButtonClick = () => {
  setCopyPasswordStatus('');
  setPassword(generatePassword());
 };

  const modalBody = (
    <div className="text-align-center">
      <div className="pad-responsive">
        <CopyLinkInput
          id="password"
          buttonText="Copy"
          value={password}
          status={copyPasswordStatus}
          styleType="secondary"
          onSuccess={() => setCopyPasswordStatus(status.SUCCESS)}
          onError={() => setCopyPasswordStatus(status.ERROR)}
          onTimeout={() => setCopyPasswordStatus(status.DEFAULT)}
        />
        {copyPasswordStatus === status.SUCCESS && (
          <Alert
            id="password-success-alert"
            status="success"
            showStateIcon={false}
            className="text-align-left"
          >
            Copied to clipboard
          </Alert>
        )}
        {copyPasswordStatus === status.ERROR && (
          <Alert
            id="password-error-alert"
            status="error"
            showStateIcon={false}
            className="text-align-left"
          >
            Password cannot be copied to clipboard
          </Alert>
        )}
      </div>
      <div className="pad-2-b">
        <ButtonSecondary
          size="sm"
          onClick={onRefreshButtonClick}
        >
          Refresh
        </ButtonSecondary>
        <ButtonPrimary
          size="sm"
          onClick={() => onPasswordFillButtonClick(password)}
          className="margin-1-l"
        >
          Fill Password
        </ButtonPrimary>
      </div>
    </div>
  );

  return (
    <div className="position-absolute" css={{ zIndex: '2', marginTop: '20px', ...styles }}>
      <FxModal
        modalHeading="Generate Password"
        modalBody={modalBody}
        onClose={onPasswordModalClose}
        theme={passwordGeneratorModalTheme}
      />
    </div>
  );
};

FxPasswordGenerator.propTypes = {
  onPasswordModalClose: PropTypes.func.isRequired,
  onPasswordFillButtonClick: PropTypes.func.isRequired,
  styles: PropTypes.shape({}),
};
